// extracted by mini-css-extract-plugin
export var Link = "Link-module--Link--s6-Di";
export var light = "Link-module--light--2FaU5";